import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const InfoLine = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M14.658,46.114a24.013,24.013,0,0,1,0-44.228A24,24,0,0,1,40.971,40.971a24.029,24.029,0,0,1-26.312,5.144ZM3.6,24A20.4,20.4,0,1,0,24,3.6,20.423,20.423,0,0,0,3.6,24ZM19.9,35.122V24a4.1,4.1,0,0,1,8.2,0V35.122a4.1,4.1,0,0,1-8.2,0Zm0-21.073a4.1,4.1,0,1,1,4.1,4.1A4.1,4.1,0,0,1,19.9,14.049Z" fill={fill}/>
    </svg>
  );
};

InfoLine.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

InfoLine.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};